import { EAlertType } from '../../types/authentication';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EAuthenticationActionTypes {
  ModalOpen = 'authentication/modalOpen',
  ModalClose = 'authentication/modalClose',
}

export interface IModalOpenPayload {
  autoRefresh: boolean;
  alert: EAlertType | null;
  useDefaultView?: boolean;
  viewData?: unknown;
  source?: string | null;
}

export type TModalOpen = ITypedReduxAction<EAuthenticationActionTypes.ModalOpen, IModalOpenPayload>;
export type TModalClose = ITypedReduxAction<EAuthenticationActionTypes.ModalClose>;

export type TAuthenticationActions = TModalOpen | TModalClose;
